// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getTriageCustomerCounts } from '@/customer/api/triage-get-counts';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useTriageCustomerCounts() {
  const { data, ...query } = useSuspenseQuery({
    queryKey: ['customer-triage', 'counts'],
    queryFn: getTriageCustomerCounts,
  });

  return { ...data, ...query };
}
